/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 * React 19 compatible replacement for react-chat-ui ChatBubble
 */

import React from 'react';
import PropTypes from 'prop-types';

const ChatBubble = ({ message, bubbleStyles = {}, customBubble }) => {
    // If a custom bubble renderer is provided, use it
    if (customBubble && typeof customBubble === 'function') {
        return customBubble({ message, bubbleStyles });
    }

    // Determine if this is a user message (id: 0) or bot message (id: 1)
    const isUser = message.id === 0;
    
    const defaultStyles = {
        text: {
            fontSize: 15,
            color: 'black',
        },
        chatbubble: {
            backgroundColor: '#ffffff',
        },
        userBubble: {
            borderRadius: 15,
            padding: '10px 15px',
            maxWidth: '70%',
            backgroundColor: '#f8f9fa',
            marginLeft: 'auto',
            marginRight: 0,
        },
        botBubble: {
            borderRadius: 15,
            padding: '10px 15px',
            maxWidth: '70%',
            backgroundColor: '#ffffff',
            marginLeft: 0,
            marginRight: 'auto',
        }
    };

    const mergedStyles = {
        text: { ...defaultStyles.text, ...bubbleStyles.text },
        chatbubble: { ...defaultStyles.chatbubble, ...bubbleStyles.chatbubble },
        userBubble: { ...defaultStyles.userBubble, ...bubbleStyles.userBubble },
        botBubble: { ...defaultStyles.botBubble, ...bubbleStyles.botBubble }
    };

    // Extract text content from message object or use as string
    const messageText = typeof message === 'object' ? (message.message || message.text || '') : message;

    return (
        <div style={mergedStyles.chatbubble}>
            <div style={isUser ? mergedStyles.userBubble : mergedStyles.botBubble}>
                <div style={mergedStyles.text}>
                    {messageText}
                </div>
            </div>
        </div>
    );
};

ChatBubble.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    bubbleStyles: PropTypes.object,
    customBubble: PropTypes.func
};

export default ChatBubble;
